module.exports = __webpack_public_path__ + "img/blue_120.b480c952.png";